export const RECENT_LOCATIONS = 'RECENT_LOCATIONS'
export const RADIUS_RECENT_LOCATION = 0.02 // unit: km
export const LAZY_SHOW_TOAST_MESSAGE = 'toast'
export const LAZY_SHOW_TOOLTIP_MESSAGE = 'tooltip'

export const SOURCE_GOOGLE = "DG"
